import React from "react";
import { Container } from "react-bootstrap";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";
import Services from "./Services";

function About() {
  return (
    <Container fluid className="about-section">
      <Container>
        <div className="about-content">
          <div className="glass-card">
            <h1 className="project-heading" style={{ marginTop: 0 }}>
              Know Who <span className="purple">I'M</span>
            </h1>
            <Aboutcard />
          </div>
          <div className="about-img">
            <img src={laptopImg} alt="about" className="img-fluid" />
          </div>
        </div>

        <h1 className="project-heading">
          My Areas of <span className="purple">Expertise</span>
        </h1>
        <div className="glass-card" style={{ textAlign: "center" }}>
          <Techstack />
        </div>

        <h1 className="project-heading">
          <span className="purple">Tools</span> I use
        </h1>
        <div className="glass-card" style={{ textAlign: "center" }}>
          <Toolstack />
        </div>

        <h1 className="project-heading">
          Freelance <span className="purple">Services</span>
        </h1>
        <div className="glass-card">
          <Services />
        </div>

        <Github />
      </Container>
    </Container>
  );
}

export default About;